export const secciones = {
  '1': 'NPS',
  '2': 'İfadeler',
  '3': 'Kontrol soruları',
  '4': 'Demografik bilgiler',
  '5': 'Açık sorular',
  '6': '4Tüm Uygulamalar',
  '7': 'Ek sorular',
  '8': 'NOM035 İfadeleri',
}
export const preguntas = {
  // '1': 'Tek seçenekli soru',
  '1': 'Çoktan seçmeli soru (Radyo düğmesi)',
  '2': 'Açık soru',
  '3': 'Beyan',
  '4': 'Çoktan seçmeli soru (Radyo düğmesi)',
  '5': '4Tüm Uygulamalar',
  '6': 'Çoktan seçmeli soru (Kontrol düğmesi)',
  '7': 'NOM035 İfadesi',
  '8': 'Ses',
}
export const abiertas = {
  '1': 'Metni aç',
  '2': 'Sayısal metin',
}
export const preguntasEspeciales = {
  '1': 'Normal soru',
  '2': 'Özel soru',
}
